import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { T } from "@freightsimple/ui-core/Typography/T";
import type { UUID } from "@/Shared/types";
import { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";
import { useState } from "react";

import { Scrollchor } from "react-scrollchor";
import { ViewShipmentsShareTrackingDialog } from "../Dialogs/ViewShipmentsShareTrackingDialog";

interface JumpBarProps {
  claimsJump?: boolean | undefined;
  shipmentState: ShipmentState;
  trackingId: UUID;
  bookedByName?: string | undefined;
}

interface JumpLinkProps {
  section: string;
  children: string;
}

function JumpLink_(props: JumpLinkProps) {
  return (
    <Button size="link">
      <Scrollchor to={`#${props.section}`}>{props.children}</Scrollchor>
    </Button>
  );
}

// The bar spans the page, so it relies on its parent letting children take a
// width — see the after-booking body, which stacks without shrink-wrapping.
function ViewShipmentsJumpBar(props: JumpBarProps) {
  const [shareOpen, setShareOpen] = useState(false);

  return (
    <Row align="center" justify="between">
      <ViewShipmentsShareTrackingDialog
        open={shareOpen}
        onOpenChange={setShareOpen}
        trackingId={props.trackingId}
      />
      <Row gap={2} align="center">
        <T size="xs" weight="light" color="muted">
          Jump to:
        </T>
        {props.claimsJump && (
          <JumpLink_ section="claims-section">Claims</JumpLink_>
        )}
        <JumpLink_ section="details-section">Details</JumpLink_>
        <JumpLink_ section="documents-section">Documents</JumpLink_>
        <JumpLink_ section="billing-section">Billing</JumpLink_>
        {props.shipmentState === ShipmentState.InTransit ||
          (props.shipmentState === ShipmentState.Delivered && (
            <JumpLink_ section="tracking-section">Tracking</JumpLink_>
          ))}
      </Row>
      <Row gap={4} align="center">
        {props.bookedByName && (
          <T size="xs" weight="light" color="muted" testId="jumpbar-booked-by">
            Booked by {props.bookedByName}
          </T>
        )}
        <Button size="link" onClick={() => setShareOpen(true)}>
          Share
        </Button>
      </Row>
    </Row>
  );
}
export default ViewShipmentsJumpBar;
